import { render, staticRenderFns } from "./AdminOrganizationsExpandedWidget.vue?vue&type=template&id=31801c57"
import script from "./AdminOrganizationsExpandedWidget.vue?vue&type=script&lang=js"
export * from "./AdminOrganizationsExpandedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports